import {
  ENTIDADE_CHANGED,
  ENTIDADE_CURRENT_CHANGED,
  ENTIDADE_LOGOUT,
} from "../../const/actionsType";

import { dates } from "investira.sdk";

const INITIAL_STATE = {
  data: [],
  current: {},
  updatedAt: null,
};

const RESET_STATE = {
  ...INITIAL_STATE,
};

function entidadeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ENTIDADE_CHANGED:
      return {
        ...state,
        data: action.payload,
      };
    case ENTIDADE_CURRENT_CHANGED:
      return {
        ...state,
        current: action.payload,
        updatedAt: dates.toDate(),
      };
    case ENTIDADE_LOGOUT:
      return {
        ...RESET_STATE,
      };
    default:
      return state;
  }
}

export default entidadeReducer;
